import Swal from "sweetalert2"

function fireModal(options) {
  return Swal.fire({
    confirmButtonText: "Entendi",
    ...options,
  })
}

function fireToast(options) {
  return Swal.fire({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    showCloseButton: true,
    timer: 4500,
    timerProgressBar: true,
    ...options,
  })
}

function normalizeKind(kind) {
  const normalized = String(kind || "info").toLowerCase()

  if (["success", "error", "warning", "info", "question"].includes(normalized)) {
    return normalized
  }

  return "info"
}

function notify({ kind = "info", title, message, mode = "modal" }) {
  const icon = normalizeKind(kind)
  const text = String(message || "")
  const heading = String(title || "Aviso")

  if (mode === "toast") {
    return fireToast({ icon, title: heading, text })
  }

  return fireModal({ icon, title: heading, text })
}

window.appAlert = {
  success(message, title = "Sucesso") {
    return notify({ kind: "success", title, message, mode: "modal" })
  },
  error(message, title = "Ops") {
    return notify({ kind: "error", title, message, mode: "modal" })
  },
  info(message, title = "Aviso") {
    return notify({ kind: "info", title, message, mode: "modal" })
  },
  warning(message, title = "Atencao") {
    return notify({ kind: "warning", title, message, mode: "modal" })
  },
  toastSuccess(message, title = "Sucesso") {
    return notify({ kind: "success", title, message, mode: "toast" })
  },
  toastError(message, title = "Ops") {
    return notify({ kind: "error", title, message, mode: "toast" })
  },
  toastInfo(message, title = "Aviso") {
    return notify({ kind: "info", title, message, mode: "toast" })
  },
  toastWarning(message, title = "Atencao") {
    return notify({ kind: "warning", title, message, mode: "toast" })
  },
  notify,
}

function consumeFlashPayloads() {
  const payloadNodes = document.querySelectorAll("script[data-app-flash-payload]")
  if (payloadNodes.length === 0) return

  const notifications = []

  payloadNodes.forEach((node) => {
    try {
      const parsed = JSON.parse(node.textContent || "[]")
      if (Array.isArray(parsed)) notifications.push(...parsed)
    } catch (error) {
      console.error("Falha ao processar notificacoes flash", error)
    }

    node.remove()
  })

  notifications.reduce((chain, notification) => {
    return chain.then(() => window.appAlert.notify(notification))
  }, Promise.resolve())
}

document.addEventListener("turbo:load", consumeFlashPayloads)

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", consumeFlashPayloads, { once: true })
} else {
  consumeFlashPayloads()
}

if (!window.__nativeAlert) {
  window.__nativeAlert = window.alert.bind(window)
}

window.alert = function patchedAlert(message) {
  return window.appAlert.toastInfo(String(message || ""), "Aviso")
}
